import createSubmit from '../../Form/createSubmitButton.jsx'
import { name } from './DoForm.jsx'

export default createSubmit(name)